export default __webpack_public_path__ + "7516e8acb4c815a40e093c3f24a7c009.png";